import React from "react";

const CarouselCaption: React.FC = () => {
  return (
    <div className="w-full bg-black bg-opacity-50 py-4">
      <div className="container mx-auto px-4 md:px-8 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-white font-clarika-pro-geo-bd">
          Quality, Reliability, and Integrity
        </h1>
      </div>
    </div>
  );
};

export default CarouselCaption;
